<template>
  <vs-wrapper>
    <vs-autocomplete
      data-test="company-selector-field"
      :items="companies"
      :label="title"
      :hint="description"
      :value="formData"
      :error-messages="errorMessages"
      :disabled="disabled"
      @input="$emit('change', $event)"
    />
  </vs-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CompanySelectorField',
  props: {
    description: String,
    errorSchema: Object,
    formData: Number,
    params: Object,
    rootSchema: Object,
    schema: Object,
    title: String,
    uiSchema: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      getAllCompanies: 'companies/getAllCompanies',
    }),
    companies() {
      const companies = Array.isArray(this.getAllCompanies)
        ? this.getAllCompanies
        : Object.values(this.getAllCompanies || {})
      return companies.map((company) => ({
        text: company.name,
        value: company.id,
        description: company.shortCode || undefined,
      }))
    },
    errorMessages() {
      const errors = this.errorSchema?.errors ?? []
      if (this.formData && typeof this.formData !== 'number') {
        errors.push('Company value expected.')
      }
      return errors
    },
  },
}
</script>

<style scoped></style>
